import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const Loading = ({ className }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 500);
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  return (
    show && (
      <div className={className}>
        <FormattedMessage id="common.loading" />
      </div>
    )
  );
};
Loading.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default Loading;
